import { Paper } from "@material-ui/core";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const LineGraph = ({ seriesData, type }) => {
  let storageData = [];
  if (type == "schoolByState") {
    storageData = seriesData.map((item) => {
      return [item.stateName, item["School Count"]];
    });
  } else {
    storageData = seriesData.map((item) => {
      return [item.month, item["School Count"]];
    });
  }

  const options = {
    title: {
      style: {
        color: "#01173E",
        fontFamily: "Rajdhani-SemiBold",
      },
      enabled: false,
      text: null,
    },
    chart: {
      type: "column",
      style: {
        color: "#002244",
      },
    },
    colors: ["#82ca9d"],
    xAxis: {
      gridLineWidth: 1,
      labels: {
        enabled: true,
        formatter: function () {
          return storageData[this.value][0];
        },
        style: {
          color: "#002244",
          fontFamily: "Rajdhani-SemiBold",
          fontSize: "14px",
        },
      },
    },
    yAxis: {
      title: {
        text: null,
      },
    },
    series: [
      {
        name: "School Count",
        data: storageData,
      },
    ],
    credits: {
      enabled: false,
    },
  };
  return (
    <div>
      <Paper className="graph-padding">
        <div className="pd-bottom-10" style={{ paddingRight: "5px" }}>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </Paper>
    </div>
  );
};

export default LineGraph;
